<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      :line-form="true"
      :title="(isEdit?'审核':'查看')+' 付款单'"
      id-key="DocId"
      :data="data"
      @edit-opened="onEditOpened"
      @details-opened="onDetailsOpened"
      :get-data-func="api.info"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="单据编号">
                <span class="detail-span">{{data.DocNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单据日期">
                <span class="detail-span">{{$commonJs.toDateString(data.DocDate)}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="往来单位">
                <span class="detail-span">{{data.TradeUnitName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务类型">
                <span class="detail-span">
                  <span v-if="data.BusinessType==0">应付款</span>
                  <span v-if="data.BusinessType==1">预付款</span>
                  <span v-if="data.BusinessType==2">直接付款</span>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经办人">
                <span class="detail-span">{{data.EmpName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="折让金额">
                <span class="detail-span">{{data.TotalAllowanceAmount}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="摘要">
                <span class="detail-span">{{data.Summary}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <span class="detail-span">{{data.Remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px;">
          <span>付款信息</span>
        </div>
        <el-table ref="table" class="tb-c-head" show-summary :data="data.Dts" border>
          <el-table-column label="结算方式" min-width="120px">
            <template slot-scope="{row}">{{row.SettleName}}</template>
          </el-table-column>
          <el-table-column label="付款账号" min-width="150px">
            <template slot-scope="{row}">{{row.AccountName}}</template>
          </el-table-column>
          <el-table-column label="付款金额" prop="PayAmount" width="110px" />
          <el-table-column label="备注" min-width="200px" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.Remark}}</template>
          </el-table-column>
        </el-table>
        <template v-if="data.BusinessType==0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>核销单据明细</span>
          </div>
          <el-table class="tb-c-head" :data="WoDocs" border>
            <el-table-column label="单据类型" prop="SrcVouTypeName" min-width="110px" />
            <el-table-column label="单据编号" prop="SourceNo" min-width="180px" show-overflow-tooltip />
            <el-table-column label="单据日期" prop="DocDate" min-width="100px">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="总核销金额" prop="Amount" min-width="90px" />
            <el-table-column label="待核销金额" prop="PayAmount" min-width="90px" />
            <el-table-column label="已核销金额" prop="AlreadyWriteoffAmount" min-width="90px" />
            <el-table-column label="本次核销金额" prop="WriteoffAmount" width="100px"/>
            <el-table-column label="折让金额" prop="AllowanceAmount" width="100px"/>
            <el-table-column label="备注" min-width="200px"/>
          </el-table>
        </template>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <template v-if="isReview==true">
          <el-button :loading="isLoading" type="success" @click="save('review')">审 核</el-button>
        </template>
        <template v-if="isReview==false&&data.PushId==null">
          <el-button :loading="isLoading" type="danger" @click="save('back')">弃 审</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/rp/pay").default,
      data: {
        DocId: 0,
        DocType: 0, //付款单/付款退款单
        DocNo: "", //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        TradeUnitType: 0, //往来单位性质 - 客户/供应商/客户&供应商/外协
        SourceId: null, //来源单据Id
        SourceNo: "", //来源单据编号
        SourceType: 0, //来源类型 - 进货单
        BusinessType: 0, //业务类型 - 应付款/预付款
        EmpId: null, //经办人
        EmpName: "",
        Summary: "", //摘要
        PayAmount: null, //付款金额
        Remark: "", //备注
        Status: 0, //草稿/未生效/已生效
        TotalAllowanceAmount: 0,
        Dts: [],
        WoDocs: [], //付款单核销单据
        WoDts: [],
        PushId: null,
      },
      WoDocs: [],
      isReview: null,
    };
  },
  methods: {
    onEditOpened(data) {
      this.isReview = true;
      this.setData(data);
    },
    onDetailsOpened(data) {
      this.isReview = false;
      this.setData(data);
    },
    setData(data) {
      this.data.TotalAllowanceAmount=data.DiscountAmount
      data.WoDocs.forEach((x) => {
        this.WoDocs.push({
          WoDocId: x.WoDocId,
          DocId: x.DocId,
          DocDate: x.DocDate,
          SourceId: x.SourceId,
          SourceNo: x.SourceNo,
          SourceType: x.SourceType,
          SrcVouType: x.SrcVouType,
          SrcVouTypeName: x.SrcVouTypeName,
          Amount: x.Amount,
          PayAmount: (x.Amount - x.AllWriteoffAmount).toFixed(2),
          AlreadyWriteoffAmount: x.AllWriteoffAmount,
          WriteoffAmount: x.WriteoffAmount,
          Remark: x.Remark,
          AllowanceAmount: x.DiscountAmount,
        });
      });
    },
    save(type) {
      console.log(type);
      this.$refs.dialog.isLoading = true;
      this.api[type](this.data.DocId).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.isReview = null;
      this.WoDocs = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.head-item {
  width: 125px;
  display: inline-block;
}
</style>